export const USER_LOCAL_STORAGE_KEY = "user_data_ssc";
